import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const Rovopepole = () => {
  return (
    <div id="main-wrapper">
      <Header />

      <div id="content" role="main">

        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: "url('/images/projects/why.jpeg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: '70px' }}>
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white">Rovopeople </h1>
                <p className="lead text-white-100 mb-0">
               Centralize employee data, automate payroll, and streamline attendance—all in real time.
                </p>
              </div>
            </div>
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1 }}></div>
        </section>

        {/* Blog Intro */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row align-items-center mb-5 g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6 mb-4 mb-md-0">
                <img 
                  src="/images/projects/rovo.png" 
                  alt="Robots on Factory Floor" 
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '350px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-3">RovoPeople: Efficient HR and Attendance Management for Modern Workforces</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                RovoPeople is a comprehensive HR and attendance management software designed to streamline employee data, track attendance, manage payroll, and maintain all HR records in one secure platform. By automating routine HR tasks, RovoPeople empowers businesses to focus on growth while ensuring accurate and efficient workforce management.
               
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What is RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">What is RovoPeople?</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                RovoPeople is an all-in-one HR software that centralizes employee data, attendance, payroll, and performance tracking. It helps HR teams manage the entire employee lifecycle efficiently, from onboarding to salary management.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {[
                { title: "Employee Database", text: "Store and manage all employee records securely in one place.", icon: "bi bi-display", img: "/images/projects/edata.png" },
                { title: "Attendance Tracking", text: "Monitor check-ins, leaves, and work hours in real time.", icon: "bi bi-activity", img: "/images/projects/at.png" },
                { title: "Payroll Management", text: "Automate salary calculations, deductions, and payslips.", icon: "bi bi-robot", img: "/images/projects/pay.png" },
                { title: "Performance Records", text: "Keep track of appraisals, promotions, and skill development.", icon: "bi bi-clock", img: "/images/projects/per.png" },
              ].map((feature, idx) => (
                <div className="col-12 col-md-6 col-lg-6 mb-4" key={idx}>
                  <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden">
                    <img 
                      src={feature.img} 
                      alt={feature.title} 
                      className="card-img-top"
                      style={{ height: '250px', objectFit: 'cover', width: '100%' }} 
                    />
                    <div className="card-body">
                      <div className="mb-2 text-primary">
                        <i className={`${feature.icon} fs-2`}></i>
                      </div>
                      <h5 className="fw-bold mb-3">{feature.title}</h5>
                      <p className="text-muted mb-0">{feature.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* Business Impact */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Business Impact</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                 RovoPeople improves HR efficiency, reduces manual errors, and saves time on administrative tasks. By providing accurate attendance and payroll data, it ensures timely salary processing, boosts employee satisfaction, and enables data-driven decisions. The software strengthens workforce management and enhances overall organizational productivity.
                </p>
                {/* <ul className="list-unstyled text-muted fs-20">
                  <li className="mb-1"> Reduce unplanned downtime and maintenance costs</li>
                  <li className="mb-1"> Improve Overall Equipment Effectiveness (OEE)</li>
                  <li className="mb-1"> Enhance product quality and traceability</li>
                  <li className="mb-1"> Optimize production throughput and energy usage</li>
                  <li className="mb-2"> Make data-driven decisions with actionable insights</li>
                </ul> */}
              </div>

              <div className="col-md-6">
                <img
                  src="/images/projects/imp1.png"
                  alt="Business Impact"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Key Features & Capabilities */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">Key Features & Capabilities</h2>
                <p className="text-muted mb-5">
                 Powerful Tools for Efficient HR Management
                </p>
              </div>
            </div>

            <div
              className="d-flex flex-row flex-nowrap"
              style={{
                gap: "1rem",
                paddingBottom: "1rem",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              onWheel={(e) => {
                e.currentTarget.scrollLeft += e.deltaY;
              }}
            >
              <style>
                {`
                  div::-webkit-scrollbar { display: none; }
                  @media (max-width: 768px) {
                    .card { min-width: 250px !important; height: auto !important; }
                    .card img { height: 180px !important; }
                  }
                `}
              </style>

              {[
                { title: "Automated Attendance", text: "Track working hours, leaves, and shifts effortlessly.", icon: "bi bi-collection", img: "/images/projects/auto1.png" },
                { title: "Integrated Payroll", text: "Generate payslips, handle taxes, and manage deductions automatically.", icon: "bi bi-speedometer2", img: "/images/projects/inte.png" },
                { title: "Employee Self-Service", text: "Let employees view attendance, salary slips, and leave balances.", icon: "bi bi-bar-chart", img: "/images/projects/emps.png" },
                { title: "Secure Data Storage", text: "Keep sensitive employee information safe and organized.", icon: "bi bi-controller", img: "/images/projects/sec.png" },
                { title: "Protocol Agnostic", text: "Supports TCP/IP, Modbus, EtherNet/IP, and more.", icon: "bi bi-layers", img: "/images/projects/pro1.png" },
                { title: "Reports & Analytics", text: "Generate insights on attendance, payroll, and workforce trends.", icon: "bi bi-layers", img: "/images/projects/rep1.png" },
              ].map((feature, idx) => (
                <div key={idx} className="card flex-shrink-0 border-0 shadow-lg rounded-4 overflow-hidden" style={{ width: "300px" }}>
                  <img src={feature.img} alt={feature.title} className="card-img-top" style={{ height: "200px", objectFit: "cover" }} />
                  <div className="card-body">
                    <div className="mb-2 text-primary">
                      <i className={`${feature.icon} fs-2`}></i>
                    </div>
                    <h5 className="fw-bold mb-2">{feature.title}</h5>
                    <p className="text-muted mb-0">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <img
                  src="/images/projects/why4.png"
                  alt="Why Choose RovoConnect"
                  className="img-fluid rounded-4 shadow-lg mb-4"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Why Choose RovoPeople?</h2>
                <p className="text-muted mb-4">
                RovoPeople simplifies HR management by automating attendance, payroll, and employee data tracking. It saves time, reduces errors, ensures transparency, and keeps all employee information secure—all in one easy-to-use platform.
                </p>
                <ul className="list-unstyled text-muted fs-6">
                  <li className="mb-3"><strong>Save Time:</strong>Automate attendance and payroll processes.</li>
                  <li className="mb-3"><strong>Reduce Errors:</strong> Minimize manual calculation mistakes.</li>
                  <li className="mb-3"><strong>Boost Transparency:</strong> Employees can access their records anytime.</li>
                  <li className="mb-3"><strong>Secure & Reliable:</strong> Protect sensitive HR data with advanced security.</li>
               <li className="mb-3"><strong>Data-Driven Decisions:</strong> Use reports to optimize workforce management.</li>
             
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion & CTA */}
        <section className="py-5 bg-dark text-white text-center">
          <div className="container">
            <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
           
             RovoPeople transforms HR management by centralizing employee data, automating payroll, and streamlining attendance tracking. It reduces administrative burden, increases accuracy, and improves employee satisfaction—making it an essential tool for modern businesses aiming for efficient and transparent HR operations.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Inquire About Partnership</a>
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default Rovopepole;
